import type {
  UpdateApprovalMutation,
  UpdateApprovalMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateApprovalDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import { mapUpdateApprovalVariables } from './approvalInputMapping';

export const useUpdateApproval = createMutationHook({
  name: 'updateApproval',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.approval.update.mutationOptions({ onSuccess }),
  mapInput: (variables: UpdateApprovalMutationVariables) =>
    mapUpdateApprovalVariables(variables),
  invalidate: (trpc) => [
    trpc.frontend.approval.globalApprovals.queryKey(),
    trpc.frontend.approval.approvalLevels.queryKey(),
    // COI-889: `ApprovalModal` builds its whole update payload from the fetched
    // approval, so a stale `approvalById` is read back into the next save.
    trpc.frontend.approval.approvalById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): UpdateApprovalMutation => ({
    update_approval_by_pk: {
      __typename: 'approval',
      Id: result.Id,
    },
  }),
  graphqlDocument: UpdateApprovalDocument,
  graphqlVariables: (variables: UpdateApprovalMutationVariables) => ({
    ...variables,
  }),
  // `getGlobalApprovals` reads the `approval` root field and `getApprovalLevels`
  // reads `approval_level`; evict all three so the Apollo (flag-off) path
  // refreshes both feeds (mirrors the tRPC branch's `invalidate`).
  evictFields: ['approval', 'approval_by_pk', 'approval_level'],
});
